let functions = [
    {
        title:'定义函数',
        func:'de-functionTransformer',
        type:'data-transformer'
    },
    {
        
        title:'异步循环',
        func:'de-asyncLoopTransformer',
        type:'data-transformer'
    },
    {
        title:'json提取',
        func:'de-jsonPathTransformer',
        type:'data-transformer'
    }
];

export {functions};